import s from "./design-system.es171.js";
import { hexToHsl as f, hslToHex as d } from "./design-system.es189.js";
import x from "./design-system.es121.js";
import { resolveComponent as h, openBlock as C, createBlock as _, withCtx as a, createVNode as i, createTextVNode as S, createElementVNode as H, normalizeStyle as k } from "vue";
/* empty css                    */
import V from "./design-system.es128.js";
import v from "./design-system.es37.js";
/* empty css                    */
import y from "./design-system.es94.js";
function u(e, o) {
  const r = e && e.a;
  let t;
  e && e.hsl ? t = s(e.hsl) : e && e.hex && e.hex.length > 0 ? t = s(e.hex) : t = s(e), t && (t.a === void 0 || t.a === null) && t.setAlpha(r || 1);
  const l = t.toHsl(), n = t.toHsv();
  return l.s === 0 && (n.h = e.h || e.hsl && e.hsl.h || o || 0), {
    hsl: l,
    hex: t.toHexString().toUpperCase(),
    rgba: t.toRgb(),
    hsv: n,
    oldHue: e.h || o || l.h,
    source: e.source,
    a: e.a || t.getAlpha()
  };
}
function B(e, o, r) {
  return `hsl(${parseFloat(e)}, ${o}%, ${r}%)`;
}
const $ = {
  name: "DsColorPicker",
  components: {
    Saturation: x,
    Box: v,
    Stack: y
  },
  props: {
    /**
     * Determines the current value of the color picker
     */
    modelValue: {
      type: String,
      default: "#58a1d8"
    }
  },
  emits: ["update:modelValue"],
  computed: {
    hsl() {
      return f(this.modelValue);
    },
    h() {
      return this.hsl.h;
    },
    colors() {
      return u(this.modelValue);
    },
    gradientH() {
      const e = [];
      for (let o = 0; o < 7; o++) {
        const r = o * 60;
        e.push(B(r, 100, 50));
      }
      return {
        backgroundImage: `linear-gradient(to right, ${e.join(", ")})`
      };
    }
  },
  methods: {
    handleHueChange(e) {
      const o = parseInt(e.target.value, 10), { s: r, l: t } = this.hsl, l = d(o, r, t);
      this.$emit("update:modelValue", l);
    },
    handleSaturationChange(e) {
      const { hex: o } = u(e, this.h);
      this.$emit("update:modelValue", o);
    }
  }
}, b = ["value"];
function D(e, o, r, t, l, n) {
  const c = h("Saturation"), m = h("Box"), p = h("Stack");
  return C(), _(p, { space: "spacing-100" }, {
    default: a(() => [
      i(c, {
        value: n.colors,
        onChange: n.handleSaturationChange
      }, null, 8, ["value", "onChange"]),
      o[1] || (o[1] = S()),
      i(m, { "padding-y": "spacing-100" }, {
        default: a(() => [
          H("input", {
            value: n.h,
            style: k(n.gradientH),
            type: "range",
            min: "0",
            max: "360",
            onInput: o[0] || (o[0] = (...g) => n.handleHueChange && n.handleHueChange(...g))
          }, null, 44, b)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const F = /* @__PURE__ */ V($, [["render", D]]);
export {
  F as default
};
//# sourceMappingURL=design-system.es49.js.map
